import React from 'react'
import classes from './FrequentlyAskedQuestions.module.sass'

const FrequentlyAskedQuestions = () => (
  <div className={classes.container}>
    <h1 className={classes.h1}>Frequently Asked Questions</h1>
    <ol className={classes.ol}>
      <li>
        <h2 className={classes.h2}>Why is the digital code to download my pictures not working?</h2>
        <ul className={classes.ul}>
          <li>
            The digital download code is different from your child’s student ID.
            The download code will be sent out to you with your package.
          </li>
        </ul>
      </li>
      <li>
        <h2 className={classes.h2}>
          I got an email saying to “Purchase Portraits” but I have already ordered.
        </h2>
        <ul className={classes.ul}>
          <li>
            If you have already purchased pictures and have a confirmation code,
            please ignore the email.
            Your pictures will be shipped about two weeks from picture day!
          </li>
        </ul>
      </li>
      <li>
        <h2 className={classes.h2}>My child’s picture has not been uploaded yet to the website.</h2>
        <ul className={classes.ul}>
          <li>
            We typically take about 3-5 days for your pictures to be
            uploaded onto the website to be available for view!
          </li>
        </ul>
      </li>
      <li>
        <h2 className={classes.h2}>
          When will I receive my package of pictures and how will I get them?
        </h2>
        <ul className={classes.ul}>
          <li>
            Your pictures will be mailed to you about 3-4 weeks after picture-day!
            They are mailed to the shipping address you entered when you ordered.
          </li>
        </ul>
      </li>
      <li>
        <h2 className={classes.h2}>I am missing my class picture in my package.</h2>
        <ul className={classes.ul}>
          <li>
            Class pictures will be shipped to the school after retake day
            and after teachers have proofed the class pictures.
          </li>
        </ul>
      </li>
      <li>
        <h2 className={classes.h2}>I do not like the way my child looks in the pictures.</h2>
        <ul className={classes.ul}>
          <li>
            Please return your package to the teacher on makeup day and request a retake.
            There is no charge for retakes. You may also return your package for a refund.
          </li>
        </ul>
      </li>
      <li>
        <h2 className={classes.h2}>Is there any editing in the photos?</h2>
        <ul className={classes.ul}>
          <li>
            There is some minor facial smoothing, color balance adjustments
            and some hair fixes but there is no retouching done unless purchased.
          </li>
        </ul>
      </li>
      <li>
        <h2 className={classes.h2}>What if I don’t have my student’s ID?</h2>
        <ul className={classes.ul}>
          <li>
            If you do not have your student’s ID,
            you can go ahead and search your student with their name and teacher.
          </li>
        </ul>
      </li>
      <li>
        <h2 className={classes.h2}>Can I pay with cash or check?</h2>
        <ul className={classes.ul}>
          <li>No, we are not taking any type of physical payments.</li>
        </ul>
      </li>
      <li>
        <h2 className={classes.h2}>
          I searched my student through his student ID but a picture of a different kid?
        </h2>
        <ul className={classes.ul}>
          <li>
            The picture you see is our placeholder picture until
            we upload your child’s picture onto our website!
            If you continue to see the placeholder image more than 7 days after picture-day,
            please call us at
            {' '}
            <a href="tel:209-567-0748">(209) 567-0748</a>
            .
          </li>
        </ul>
      </li>
    </ol>
  </div>
)

export default FrequentlyAskedQuestions
